<template>
  <div class="view agent-info">
    <h1>{{ $t('agent.label.affiliate') }}</h1>
  </div>
</template>

<script>
export default {
  name: 'AgentInfo',

  data() {
    return {
    }
  },

  components: {
  }
}
</script>
